"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_utils_1 = require("prosemirror-utils");

function findCollapsedNodes(doc) {
  var blocks = prosemirror_utils_1.findBlockNodes(doc);
  var nodes = [];
  var withinCollapsedHeading;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = blocks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var block = _step.value;

      if (block.node.type.name === "heading") {
        if (!withinCollapsedHeading || block.node.attrs.level <= withinCollapsedHeading) {
          if (block.node.attrs.collapsed) {
            if (!withinCollapsedHeading) {
              withinCollapsedHeading = block.node.attrs.level;
            }
          } else {
            withinCollapsedHeading = undefined;
          }

          continue;
        }
      }

      if (withinCollapsedHeading) {
        nodes.push(block);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return nodes;
}

exports.default = findCollapsedNodes;